import { CSSProgressiveCaption01Semibold } from "@caisy/league";
import styled from "styled-components";

export const SOnboardingTourCardDescription = styled.div`
  ${CSSProgressiveCaption01Semibold};
  color: var(--text-03);
`;
